import React, { useEffect, useState } from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import SubjectHeader from "./SubjectHeader";
import SubjectTable from "./SubjectTable";

const SubjectList = () => {
  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <SubjectHeader />
          </PageHeader>
          <div className="main-content">
            <div className="row">
              <SubjectTable />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default SubjectList;
